import React from "react";
import Logo from "../assets/logo-applaby.png";
import { useTranslation } from "react-i18next";

import { Helmet } from "react-helmet-async";

export default function TermsPage() {
	const { t } = useTranslation();

	return (
		<>
			<Helmet>
				<title>{t("seo.terms.title")}</title>
				<meta name="description" content={t("seo.terms.description")} />
				<meta name="robots" content="noindex, follow" />
			</Helmet>
			<div className="bg-gray-50 min-h-screen py-12">
				<section className="max-w-4xl mx-auto bg-white shadow-md rounded-xl p-8">
					<a
						href={"/"}
						className="mb-10"
						style={{
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
						}}
					>
						<img
							src={Logo}
							alt="Logo Applaby"
							style={{ height: "40px", objectFit: "contain" }}
						/>
					</a>
					<div class="container">
						<h1 className="text-3xl font-bold text-gray-900 mb-2">
							Términos y Condiciones
						</h1>
						<p className="text-sm text-gray-500 mb-8">
							Actualizado al 24 de setiembre de 2025
						</p>
						<h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">
							1. Ámbito de aplicación
						</h2>
						<p className="text-gray-700 mb-3">
							Estos Términos y Condiciones regulan el uso de la plataforma
							Applaby, propiedad de Yowlu SL, con sede en Barcelona (España).
						</p>
						<p className="text-gray-700 mb-3">
							El servicio de Applaby está dirigido exclusivamente a empresas,
							negocios o profesionales. Applaby no ofrece servicios a
							consumidores finales (particulares).
						</p>
						<p className="text-gray-700 mb-3">
							Al acceder y utilizar Applaby, confirmas que actúas en calidad de
							empresa o profesional y aceptas quedar vinculado por estos
							Términos y Condiciones.
						</p>
						<p>
							A efectos de estos Términos y Condiciones, cualquier empresa,
							negocio o profesional que se registre en la plataforma Applaby y
							contrate nuestros servicios será referido en lo sucesivo como el
							“Negocio” o el “Cliente”.
						</p>
						<h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">
							2. Cambios en precios, planes y servicios
						</h2>
						<p className="text-gray-700 mb-3">
							Applaby podrá actualizar sus precios, planes de suscripción,
							características y/o condiciones de uso.
						</p>
						<ul className="list-disc pl-6 mb-4 space-y-2 text-gray-700">
							<li>
								Preaviso: comunicaremos cualquier cambio de precio o plan con al
								menos 15 días naturales de antelación, a través de la plataforma
								y/o por correo electrónico.
							</li>
							<li>
								Aplicación: los nuevos precios se aplicarán en el siguiente
								período de renovación de tu suscripción. Si no estás de acuerdo,
								podrás cancelar antes de la fecha de efecto sin penalización.
							</li>
							<li>
								Actualizaciones del servicio: podremos introducir mejoras,
								cambios o retirar funcionalidades. En caso de cambios
								sustanciales que reduzcan de forma relevante una funcionalidad,
								daremos un preaviso razonable, salvo cambios urgentes por
								motivos de seguridad o cumplimiento legal.
							</li>
							<li>
								Cambios de plan: los upgrades podrán cobrarse de forma
								prorrateada hasta el fin del ciclo en curso; los downgrades se
								aplicarán en la renovación siguiente.
							</li>
							<li>
								Impuestos y moneda: los precios se entienden sin impuestos(p.
								ej., IVA) y en EUR, aplicándose los tributos que correspondan
								según normativa.
							</li>
							<li>
								Promociones: las ofertas o descuentos podrán estar sujetos a
								condiciones específicas y no son acumulables, salvo indicación
								expresa.
							</li>
						</ul>
						<h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">
							3. Licencia de uso
						</h2>
						<p className="text-gray-700 mb-3">
							Applaby te otorga una licencia revocable, no exclusiva, no
							transferible y limitada para utilizar la plataforma con el único
							fin de crear, gestionar y publicar aplicaciones y servicios
							digitales de tu negocio, conforme a estos Términos y Condiciones.
						</p>
						<p className="text-gray-700 mb-3">
							Applaby es titular de la tecnología y plataforma, mientras que el
							negocio es titular de los contenidos que incorpora en su
							aplicación, web o iframe.
						</p>
						<h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">
							4. Restricciones
						</h2>
						<p className="text-gray-700 mb-3">
							El negocio que utiliza Applaby se compromete a no realizar, ni
							permitir a terceros realizar, las siguientes acciones:
						</p>
						<ul className="list-disc pl-6 mb-4 space-y-2">
							<li className="text-gray-700 leading-relaxed">
								Revender, sublicenciar, alquilar o poner a disposición de
								terceros la plataforma Applaby sin autorización expresa.
							</li>
							<li className="text-gray-700 leading-relaxed">
								Modificar, crear obras derivadas, descompilar o aplicar técnicas
								de ingeniería inversa sobre la plataforma.
							</li>
							<li className="text-gray-700 leading-relaxed">
								Eliminar u ocultar avisos de propiedad intelectual, marcas o
								derechos de autor de Applaby.
							</li>
						</ul>
						<h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">
							5. Relación con los usuarios finales
						</h2>
						<p className="text-gray-700 mb-3">
							Applaby proporciona infraestructura tecnológica para que los
							negocios gestionen sus servicios y datos.
						</p>
						<p className="text-gray-700 mb-3">
							La relación contractual y legal con los usuarios finales
							corresponde al negocio que utiliza Applaby.
						</p>
						<p className="text-gray-700 mb-3">
							Cualquier política de precios, cancelaciones, reembolsos o
							reclamaciones debe ser gestionada directamente entre el negocio y
							sus clientes.
						</p>
						<p className="text-gray-700 mb-3">
							Applaby actúa como encargado del tratamiento de datos en nombre
							del negocio, conforme a las instrucciones de este y de acuerdo con
							la normativa de protección de datos aplicable, y no utilizará los
							datos para ningún otro fin sin el consentimiento del negocio.
						</p>
						<h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">
							6. Obligaciones del negocio
						</h2>
						<p className="text-gray-700 mb-3">
							El negocio será el único responsable frente a sus usuarios finales
							de la veracidad, calidad, legalidad y adecuación de los servicios,
							contenidos y actividades que ofrezca a través de la plataforma
							Applaby.
						</p>
						<p className="text-gray-700 mb-3">
							El negocio que utiliza Applaby se compromete a:
						</p>
						<ul className="list-disc pl-6 mb-4 space-y-2">
							<li className="text-gray-700 leading-relaxed">
								Cumplir la legislación vigente, incluidas las normativas de
								protección de datos.
							</li>
							<li className="text-gray-700 leading-relaxed">
								Incluir en sus propios Términos y Condiciones y Política de
								Privacidad una mención expresa a Applaby como proveedor
								tecnológico.
							</li>
							<li className="text-gray-700 leading-relaxed">
								Asegurarse de que el contenido de sus aplicaciones cumple con
								las políticas de Apple y Google Play. Applaby no garantiza la
								aceptación de la aplicación en estas tiendas ni se hace
								responsable si es rechazada o eliminada por incumplimiento de
								dichas normativas.
							</li>
							<li className="text-gray-700 leading-relaxed">
								Gestionar de forma correcta las transacciones, cancelaciones,
								reembolsos y cualquier disputa con sus usuarios finales.
							</li>
							<li className="text-gray-700 leading-relaxed">
								En caso de utilizar un iframe proporcionado por Applaby,
								responsabilizarse de su correcta integración, de la gestión de
								los datos de los usuarios y de garantizar el cumplimiento de la
								normativa aplicable.
							</li>
						</ul>
						<p className="text-gray-700 mb-3">
							El negocio que utiliza Applaby es responsable de disponer de sus
							propios Términos y Condiciones y Política de Privacidad, donde
							deberá informar a sus clientes sobre sus políticas de servicios,
							pagos, cancelaciones, devoluciones y protección de datos. En
							dichos textos legales, el negocio deberá incluir una mención a
							Applaby como proveedor tecnológico de la infraestructura,
							aclarando que la relación contractual con los usuarios finales es
							exclusivamente entre el negocio y sus clientes.
						</p>
						<p className="text-gray-700 mb-3">
							Applaby no será responsable de incumplimientos legales,
							regulatorios o técnicos derivados del uso indebido de la
							plataforma por parte del negocio.
						</p>
						<p className="text-gray-700 mb-3">
							En ningún caso Applaby asumirá responsabilidad alguna por
							reclamaciones, daños o conflictos derivados de la relación entre
							el negocio y sus usuarios finales.
						</p>
						<p className="text-gray-700 mb-3">
							El negocio mantendrá indemne y exonerará de toda responsabilidad a
							Applaby frente a cualquier reclamación, sanción, daño o coste
							(incluidos honorarios legales) derivados de:
						</p>
						<ul className="list-disc pl-6 mb-4 space-y-2 text-gray-700">
							<li>
								El incumplimiento por parte del negocio de sus obligaciones
								legales, contractuales o regulatorias.
							</li>
							<li>
								La prestación de servicios o contenidos ofrecidos a través de la
								plataforma.
							</li>
							<li>
								El uso indebido o no autorizado de la plataforma por parte del
								negocio o de sus usuarios finales.
							</li>
						</ul>
						<h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">
							7. Datos y seguridad
						</h2>
						<p className="text-gray-700 mb-3">
							Applaby aplica medidas técnicas y organizativas para proteger los
							datos personales frente a accesos no autorizados, pérdida,
							alteración o destrucción.
						</p>
						<p className="text-gray-700 mb-3">
							En caso de incidente de seguridad, Applaby notificará al negocio
							afectado y tomará las medidas necesarias para mitigar el impacto.
						</p>
						<p className="text-gray-700 mb-3">
							El negocio es responsable de la correcta gestión y protección de
							los datos de sus usuarios finales, así como de cumplir con las
							obligaciones de comunicación que la normativa de protección de
							datos le imponga.
						</p>
						<p className="text-gray-700 mb-3">
							En ningún caso Applaby será responsable de pérdidas indirectas,
							daños consecuenciales o lucro cesante que puedan derivarse de
							incidentes de seguridad, interrupciones técnicas o accesos no
							autorizados, salvo en los casos en que la normativa aplicable
							disponga lo contrario. El negocio será el único responsable de los
							daños derivados de un uso inadecuado de la plataforma o del
							incumplimiento de sus propias obligaciones legales en materia de
							protección de datos.
						</p>
						<p className="text-gray-700 mb-3">
							<strong>
								Las cuotas de suscripción abonadas a Applaby no son
								reembolsables.
							</strong>{" "}
							El negocio podrá cancelar su suscripción en cualquier momento,
							manteniendo acceso hasta el final del periodo ya pagado.
						</p>
						<p className="text-gray-700 mb-3">
							Applaby ofrece un periodo de prueba gratuito de 30 días, durante
							el cual el negocio puede darse de baja sin coste alguno.
						</p>
						<h3 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
							Derechos de los usuarios finales
						</h3>
						<p className="text-gray-700 mb-3">
							Los usuarios finales tienen derecho a acceder, rectificar o
							solicitar la eliminación de sus datos personales, así como a
							ejercer los demás derechos reconocidos por la normativa de
							protección de datos.
						</p>
						<p className="text-gray-700 mb-3">
							{" "}
							Para ejercer estos derechos, los usuarios deberán dirigirse
							directamente al negocio titular de la aplicación o servicio creado
							con Applaby. Applaby, en calidad de proveedor tecnológico y
							encargado del tratamiento, actuará siguiendo las instrucciones del
							negocio y prestará la asistencia técnica necesaria para facilitar
							el cumplimiento de estas solicitudes.
						</p>
						<h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">
							7bis. Encargado del Tratamiento de Datos
						</h2>
						<p className="text-gray-700 mb-3">
							En relación con los datos personales de los usuarios finales
							tratados a través de la plataforma, Applaby actuará en calidad de{" "}
							<strong>Encargado del Tratamiento</strong>, mientras que el
							negocio que contrata los servicios será el{" "}
							<strong>Responsable del Tratamiento</strong>.
						</p>
						<p className="text-gray-700 mb-3">
							Applaby se compromete a tratar los datos personales únicamente
							conforme a las instrucciones documentadas del negocio, a
							implementar medidas técnicas y organizativas adecuadas para
							garantizar un nivel de seguridad acorde con el riesgo, y a no
							utilizar dichos datos para finalidades propias.
						</p>
						<p className="text-gray-700 mb-3">
							El negocio, como Responsable del Tratamiento, garantiza que
							dispone de la base legal adecuada para el tratamiento de los datos
							personales de sus usuarios finales y que ha proporcionado la
							información requerida por la normativa vigente en materia de
							protección de datos.
						</p>
						<p className="text-gray-700 mb-3">
							En caso de que un usuario final ejerza sus derechos de acceso,
							rectificación, supresión, oposición, portabilidad o limitación del
							tratamiento, Applaby asistirá al negocio en la medida de lo
							posible para facilitar la gestión de dichas solicitudes.
						</p>
						<p className="text-gray-700 mb-3">
							Asimismo, Applaby notificará al negocio cualquier incidente de
							seguridad que afecte a los datos personales de los usuarios
							finales tan pronto como tenga conocimiento del mismo, incluyendo
							la información relevante para que el negocio pueda cumplir con sus
							obligaciones legales.
						</p>
						<h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">
							8. Pagos y suscripciones
						</h2>
						<p className="text-gray-700 mb-3">
							Applaby utiliza Stripe como pasarela de pago segura para cobrar
							las cuotas de suscripción de la plataforma.
						</p>
						<p className="text-gray-700 mb-3">
							Para aceptar pagos de sus propios clientes (pedidos, reservas o
							servicios), cada negocio debe conectar su propia cuenta de Stripe
							con la plataforma Applaby. Los pagos se procesan directamente a
							través de la cuenta de Stripe del negocio, sin que Applaby
							intervenga en la gestión ni custodia de esos fondos.
						</p>
						<p className="text-gray-700 mb-3">
							El procesamiento de pagos se realiza a través de Stripe, que
							aplica sus propias medidas de seguridad y cumplimiento normativo.
							Applaby no almacena ni gestiona datos de tarjetas de crédito o
							información financiera de los clientes finales.
						</p>
						<p className="text-gray-700 mb-3">
							Cada negocio es responsable de establecer y comunicar sus
							políticas de cancelaciones, reembolsos y gestión de disputas con
							sus clientes. Applaby no asume responsabilidad en las
							transacciones realizadas entre el negocio y sus usuarios finales.
						</p>
						<p className="text-gray-700 mb-3">
							En caso de incidencias, reclamaciones o devoluciones relacionadas
							con pagos de clientes, el negocio será el único responsable de
							resolverlas directamente a través de su propia cuenta de Stripe y
							frente a sus usuarios finales.
						</p>
						<p className="text-gray-700 mb-3">
							En caso de disputas relacionadas con pagos procesados a través de
							Stripe, el negocio y sus clientes deben dirigirse directamente al
							servicio de soporte de Stripe. Applaby no interviene en dichas
							reclamaciones.
						</p>
						<h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">
							9. Propiedad intelectual
						</h2>
						<p className="text-gray-700 mb-3">
							Todos los derechos de propiedad intelectual e industrial sobre la
							plataforma, el software, el diseño, los contenidos y, en general,
							todos los elementos incluidos en Applaby pertenecen a Yowlu SL o
							cuentan con licencia de uso.
						</p>
						<p className="text-gray-700 mb-3">
							La marca <strong>Applaby®</strong> es una marca registrada de
							Yowlu SL. Queda prohibida su reproducción, imitación, utilización
							o inclusión en cualquier otro signo distintivo sin autorización
							expresa y por escrito de Yowlu SL.
						</p>
						<p className="text-gray-700 mb-3">
							Los clientes que contraten los servicios de Applaby no adquieren
							ningún derecho de propiedad intelectual o industrial sobre la
							plataforma ni sobre sus contenidos, marcas, diseños, logotipos u
							otros elementos identificativos, que son titularidad exclusiva de
							Yowlu SL (Applaby) o de sus licenciantes. El cliente únicamente
							obtiene un derecho de uso limitado, no exclusivo e intransferible,
							conforme a lo previsto en estos Términos y Condiciones.
						</p>
						<h3 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
							Enlaces a sitios de terceros
						</h3>
						<p className="text-gray-700 mb-3">
							La plataforma Applaby puede incluir integraciones con servicios de
							terceros (como Stripe, Google u otros), así como enlaces a sitios
							web externos. Estos servicios o sitios son operados por entidades
							ajenas a Applaby.
						</p>
						<p className="text-gray-700 mb-3">
							El uso de estos servicios de terceros está sujeto exclusivamente a
							los términos y condiciones establecidos por dichos proveedores.
							Applaby no asume responsabilidad alguna por la disponibilidad,
							exactitud, legalidad, calidad o cualquier otro aspecto de dichos
							servicios o enlaces externos.
						</p>
						<p className="text-gray-700 mb-3">
							La inclusión de estos servicios o enlaces se proporciona
							únicamente como una conveniencia para los negocios. El acceso y
							uso de los mismos se realiza bajo la propia responsabilidad del
							negocio o del usuario final.
						</p>
						<h3 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
							Sugerencias
						</h3>
						<p className="text-gray-700 mb-3">
							Cualquier comentario, idea, propuesta de mejora, feedback o
							sugerencia que el negocio proporcione a Applaby en relación con la
							plataforma se considerará no confidencial y pasará a ser propiedad
							exclusiva de Yowlu SL (Applaby).
						</p>
						<p className="text-gray-700 mb-3">
							El negocio cede de forma gratuita, irrevocable, mundial y sin
							limitación temporal todos los derechos de uso sobre dichas
							sugerencias, incluyendo la facultad de utilizarlas, modificarlas,
							publicarlas, reproducirlas, redistribuirlas y explotarlas
							libremente, sin que ello genere derecho a compensación económica
							ni reconocimiento alguno a favor del negocio.
						</p>
						<h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">
							10. Contenidos de los clientes
						</h2>
						<p className="text-gray-700 mb-3">
							Los negocios mantienen en todo momento la titularidad de los
							contenidos que incorporen a la plataforma Applaby, incluyendo
							textos, imágenes, logotipos, marcas propias, descripciones de
							servicios o productos y cualquier otro material que suban al
							sistema.
						</p>
						<p className="text-gray-700 mb-3">
							Al introducir dichos contenidos, el negocio concede a Yowlu SL una
							licencia no exclusiva, mundial y limitada al tiempo de duración
							del contrato, para alojar, reproducir y mostrar dichos contenidos
							en la app o web generada a través de Applaby, únicamente con la
							finalidad de prestar el servicio contratado.
						</p>
						<p className="text-gray-700 mb-3">
							El negocio declara y garantiza que dispone de los derechos
							necesarios sobre los contenidos que incorpora a la plataforma y
							que su uso no infringe derechos de terceros. El negocio mantendrá
							indemne y exonerará de toda responsabilidad a Applaby frente a
							cualquier reclamación, daño, sanción o coste (incluidos honorarios
							legales) derivado del uso o publicación de dichos contenidos.
						</p>
						<h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">
							11. Limitación de responsabilidad
						</h2>
						<p className="text-gray-700 mb-3">
							En ningún caso Applaby será responsable de:
						</p>
						<ul className="list-disc pl-6 mb-4 space-y-2">
							<li className="text-gray-700 leading-relaxed">
								Daños indirectos, incidentales, consecuenciales, pérdida de
								beneficios o lucro cesante del negocio que contrata Applaby.
							</li>
							<li className="text-gray-700 leading-relaxed">
								Contenidos, servicios o transacciones publicados por los
								negocios a través de la plataforma.
							</li>
							<li className="text-gray-700 leading-relaxed">
								Problemas derivados de la integración de iframes o de la
								aceptación/rechazo de aplicaciones en tiendas externas (Apple,
								Google Play).
							</li>
							<li className="text-gray-700 leading-relaxed">
								Interrupciones temporales, errores o incidencias técnicas en la
								disponibilidad de la plataforma, salvo que se haya pactado
								expresamente un Acuerdo de Nivel de Servicio (SLA) por escrito
								entre Applaby y el negocio.
							</li>
						</ul>
						<p className="text-gray-700 mb-3">
							La responsabilidad total de Applaby frente al negocio, cualquiera
							que sea la causa o la teoría jurídica invocada, quedará en todo
							caso limitada al importe efectivamente abonado por el negocio a
							Applaby durante el mes anterior al hecho que haya originado la
							reclamación, sin que ello implique reconocimiento de obligación de
							devolución automática de cuotas ni derecho de reembolso salvo
							resolución judicial firme.
						</p>
						<p className="text-gray-700 mb-3">
							El negocio mantendrá indemne a Applaby frente a cualquier
							reclamación de terceros derivada de los contenidos, servicios o
							datos que publique o gestione a través de la plataforma.
						</p>
						<p className="text-gray-700 mb-3">
							La plataforma Applaby se ofrece ‘tal cual’ y ‘según
							disponibilidad’, sin garantizar que esté libre de errores o
							interrupciones. No se asegura que la aceptación en las tiendas de
							aplicaciones (Apple, Google Play) esté garantizada, ni que las
							integraciones con servicios externos estén libres de incidencias.
						</p>
						<h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">
							12. Terminación del servicio
						</h2>
						<p className="text-gray-700 mb-3">
							El negocio puede dar por terminada su suscripción a Applaby en
							cualquier momento, de acuerdo con las condiciones de cancelación
							establecidas en la plataforma.
						</p>
						<p className="text-gray-700 mb-3">
							Applaby podrá suspender o cancelar el acceso a la plataforma de
							manera inmediata en caso de:
						</p>
						<ul className="list-disc pl-6 mb-4 space-y-2">
							<li className="text-gray-700 leading-relaxed">
								Impago de las cuotas correspondientes.
							</li>
							<li className="text-gray-700 leading-relaxed">
								Incumplimiento de estos Términos y Condiciones.
							</li>
							<li className="text-gray-700 leading-relaxed">
								Uso fraudulento, abusivo o ilegal de la plataforma.
							</li>
						</ul>
						<p className="text-gray-700 mb-3">
							La terminación del servicio no exime al negocio del pago de las
							cantidades que se encuentren pendientes en el momento de la
							cancelación, ni limita el derecho de Applaby a reclamar los
							importes adeudados o indemnizaciones que correspondan por daños y
							perjuicios.
						</p>
						<h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">
							12bis. Fuerza mayor
						</h2>
						<p className="text-gray-700 mb-3">
							Applaby no será responsable por incumplimientos o retrasos en la
							prestación de sus servicios debidos a causas de fuerza mayor o
							circunstancias fuera de su control razonable, incluyendo, a título
							enunciativo y no limitativo: fallos de terceros proveedores,
							cortes de internet o energía, desastres naturales, conflictos
							laborales, ataques cibernéticos, pandemias o disposiciones
							gubernamentales.
						</p>
						<p className="text-gray-700 mb-3">
							En tales casos, las obligaciones de Applaby quedarán suspendidas
							mientras dure la situación de fuerza mayor, sin que ello genere
							derecho a indemnización alguna para el negocio.
						</p>
						<h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">
							13. Divisibilidad
						</h2>
						<p className="text-gray-700 mb-3">
							Si alguna de las disposiciones de estos Términos y Condiciones
							fuese declarada nula, inválida o inaplicable por un tribunal
							competente, dicha disposición se interpretará de la manera que
							mejor se ajuste a su finalidad, y el resto de disposiciones
							permanecerán en pleno vigor y efecto.
						</p>
						<p className="text-gray-700 mb-3">
							Estos Términos y Condiciones, junto con la Política de Privacidad
							y cualquier otro aviso legal publicado por Applaby, constituyen el
							acuerdo íntegro entre el negocio y Applaby en relación con el uso
							de la plataforma.
						</p>
						<p className="text-gray-700 mb-3">
							La falta de ejercicio o exigencia por parte de Applaby de
							cualquier derecho o disposición de estos Términos no constituirá
							una renuncia al mismo, ni afectará a su validez futura.
						</p>
						<h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">
							14. Uso de cookies
						</h2>
						<p className="text-gray-700 mb-3">
							El uso de cookies en la plataforma Applaby se regula en nuestra{" "}
							<a
								href="/cookies"
								target="_blank"
								rel="noopener noreferrer"
								className="underline text-primary hover:text-primary/80"
							>
								Política de Cookies
							</a>
							, que forma parte integrante de estos Términos y Condiciones.
						</p>
						<h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">
							15. Disposiciones finales
						</h2>
						<p className="text-gray-700 mb-3">
							Estos Términos y Condiciones, junto con la Política de Privacidad,
							constituyen el acuerdo completo entre Applaby y el negocio en
							relación con el uso de la plataforma, y sustituyen cualquier
							acuerdo previo.
						</p>
						<p className="text-gray-700 mb-3">
							Si alguna disposición se considera inválida o inaplicable, ello no
							afectará al resto, que permanecerán en pleno vigor y efecto.
						</p>
						<p className="text-gray-700 mb-3">
							El hecho de que Applaby no ejerza un derecho o no exija el
							cumplimiento de una obligación en un momento determinado no
							supondrá renuncia a ese derecho u obligación en el futuro.
						</p>
						<h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">
							16. Jurisdicción y ley aplicable
						</h2>
						<p className="text-gray-700 mb-3">
							Estos Términos y Condiciones se rigen por la legislación española.
						</p>
						<p className="text-gray-700 mb-3">
							Cualquier controversia será resuelta en los Juzgados y Tribunales
							de Barcelona (España).
						</p>
						<h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">
							Contáctanos
						</h2>
						<p className="text-gray-700 mb-3">
							No dudes en ponerte en contacto con nosotros si tienes alguna
							pregunta.
						</p>
						<ul className="list-disc pl-6 mb-4 space-y-2">
							<li className="text-gray-700 leading-relaxed">
								Via Email:{" "}
								<a href="mailto:info@applaby.com" class="trackableLink">
									info@applaby.com
								</a>
							</li>
						</ul>
					</div>
				</section>
			</div>
		</>
	);
}
